var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row contenedor-videos"},[_c('div',{staticClass:"col-12 contenedor-video"},[_c('video',{staticClass:"video",attrs:{"src":_vm.rutaDeVideo,"controls":""}},[_c('p',[_vm._v("Su navegador no soporta vídeos HTML5.")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ee31b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginaOficial/PaginaPrincipal/VisorVideos.vue
// module id = null
// module chunks = 